import { render, staticRenderFns } from "./bimTextDesc.vue?vue&type=template&id=521d930c&scoped=true&lang=html&"
import script from "./bimTextDesc.vue?vue&type=script&lang=js&"
export * from "./bimTextDesc.vue?vue&type=script&lang=js&"
import style0 from "./bimTextDesc.vue?vue&type=style&index=0&id=521d930c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d930c",
  null
  
)

export default component.exports